module.exports = __webpack_public_path__ + "static/img/Home04@2x.b82ccc8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Home04@2x.png
// module id = bPar
// module chunks = 1